import Vue from 'vue'
import wsHttps from "@/components/tools/request/https-ws.js";
import utils from "@/components/tools/utils.js";
import bHttps from "@/components/tools/request/https-b.js";
import aHttps from "@/components/tools/request/https-a.js";

const state = {
    // 后台请求地址
    serverIP: '',
    // websocket 相关
    wsUrl: 'ws://192.168.1.156:9200/ws',
    msgType: {
        HEART: 0,                   // 心跳
        CONNECT: 1,                 // 建立连接
        ERROR: 2,                   // 无法处理的消息回执
        REPEAT: 3,                   // 重复账号
        START_LESSON: 10,           // 开始授课
        AUTO_ATTEND_START: 11,      // 自动考勤
        AUTO_ATTEND_STOP: 18,       // 停止自动考勤
        AUTO_ATTEND_REPLAY: 19,     // 学生考勤签到
        RESOURCE_URL: 12,           // 资源
        RESOURCE_EXER: 13,          // 习题
        RUSH_ANSWER_READY: 14,      // 准备抢答
        RUSH_ANSWER_ON: 15,         // 开始抢答
        RUSH_ANSWER_OFF: 16,        // 结束抢答
        RUSH_ANSWER_REPLAY: 17,     // 学生回复抢答
        TASK_RECEIVE_COMMAND: 22,   // 接收学生端执行任务
        TASK_RECEIVE_END: 23,       // 接收学生端结束任务
        START_DISCUSS: 31,       // 接收学生端结束任务
        STOP_DISCUSS: 32,       // 接收学生端结束任务
        END_LESSON: 50,             // 下课
        SUBMIT_EXER: 63,             // 下课
        PARSE_PPT_SUCCESS: 102,      //PPT解析成功
        PARSE_PPT_WAITING: 103,     //PPT等待解析
        TEAM_CHAT:  60,            // 小组聊天（包括文本、图片、语音、文档、视频
        CHAT_CLASS:  61,            // 班级聊天（包括文本、图片、语音、文档、视频
    },
    allKnowList: [],                // 知识点
    treeList: [],
    knowTree: [],                   // 知识点树形结构
    userSchoolCourseList: [],       // 当前用户学校的课程
    exerStarPath: '@/assets/images/theme1/common/exer-star.png',
    fromUserList: [],        // 留言学生列表
}

const actions = {
    setServerIP({commit}) {
        wsHttps.getServerIP().then(res => {
            commit('SET_SERVER_IP', res.data.serverIpPort);
            commit('SET_WS_URL', res.data.nettyIpPort.replace("app.",""));
        })
    },
    getFromUserList({commit}, param) {
        aHttps.listStudentByTeacherId(param).then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_FROM_USER_LIST', res.data);
            }
        });
    },
    getSchoolCourseList({commit}) {
        bHttps.listUserCourse().then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_SCHOOL_COURSE_LIST', res.data);
            }
        });
    },
    getAllKnowList({commit}, param) {
        let _param = {
            courseId: param.courseId ? param.courseId : ''
        }
        bHttps.listKp(_param).then(res => {
            if (!utils.requestSuccess(res)) {
                return;
            }
            commit('SET_ALL_KNOW_LIST', res.data);

            var treeList = [];
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].upperId == 0) {
                    var item = {
                        id: res.data[i].id,
                        name: res.data[i].name,
                        upperId: res.data[i].upperId,
                        upperIds: res.data[i].upperIds,
                        isLeaf: res.data[i].isLeaf,
                        children: []
                    }
                    treeList.push(item)
                }
            }
            for (var i = 0; i < treeList.length; i++) {
                for (var j = 0; j < res.data.length; j++) {
                    if (treeList[i].id == res.data[j].upperId) {
                        var item = {
                            id: res.data[j].id,
                            name: res.data[j].name,
                            upperId: res.data[j].upperId,
                            upperIds: res.data[j].upperIds,
                            isLeaf: res.data[j].isLeaf,
                            children: []
                        }
                        treeList[i].children.push(item);
                    }
                }
            }

            for (var i = 0; i < treeList.length; i++) {
                for (var j = 0; j < treeList[i].children.length; j++) {
                    for (var k = 0; k < res.data.length; k++) {
                        if (treeList[i].children[j].id == res.data[k].upperId) {
                            var item = {
                                id: res.data[k].id,
                                name: res.data[k].name,
                                upperId: res.data[k].upperId,
                                upperIds: res.data[k].upperIds,
                                isLeaf: res.data[k].isLeaf,
                                children: []
                            }
                            treeList[i].children[j].children.push(item);
                        }
                    }
                }
            }
            ;

            commit('SET_TREE_LIST', treeList)

            // 由id和upperId组成的树形结构二维数据,
            let result = [];
            for (let i = 0; i < res.data.length; i++) {
                let row = res.data[i];
                // 此行代码用以统一根节点的upperId, 跟节点的upperId 可以为 0 或 null
                row.upperId = row.upperId ? row.upperId : 0
                if (result[row.id]) {
                    Object.assign(result[row.id],
                        {
                            id: row.id,
                            name: row.name,
                            upperId: row.upperId,
                            upperIds: row.upperIds,
                            isLeaf: row.isLeaf,
                        }
                    );
                } else {
                    result[row.id] = {
                        id: row.id,
                        name: row.name,
                        upperId: row.upperId,
                        upperIds: row.upperIds,
                        isLeaf: row.isLeaf,
                        children: []
                    }
                }
                if (result[row.upperId]) {
                    result[row.upperId].children.push(result[row.id]);
                } else {
                    result[row.upperId] = {children: [result[row.id]]};
                }
            }
            if (utils.isEmptyArray(result)) {
                commit('SET_KNOW_TREE', []);
            } else {
                commit('SET_KNOW_TREE', result[0].children);
            }
            // console.log("children===",result[0].children)
        });
    }

}

const mutations = {
    ['SET_SERVER_IP'](state, val) {
        Vue.set(state, 'serverIP', val);
    },
    ['SET_WS_URL'](state, val) {
        Vue.set(state, 'wsUrl', val);
    },
    ['SET_ALL_KNOW_LIST'](state, list) {
        Vue.set(state, 'allKnowList', list);

    },
    ['SET_KNOW_TREE'](state, list) {
        Vue.set(state, 'knowTree', list);
    },
    ['SET_SCHOOL_COURSE_LIST'](state, list) {
        Vue.set(state, 'userSchoolCourseList', list);
    },
    ['SET_FROM_USER_LIST'](state, list) {
        Vue.set(state, 'fromUserList', list);
    },
    ['SET_TREE_LIST'](state, list) {
        Vue.set(state, 'treeList', list)
    }
}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js